import './style.scss'
import { useEffect } from 'react'
import { Button } from "antd"
import errorImg from '../../assets/techissue.png'
import { logConsoleError } from '../../actions'
import { useRouteError } from 'react-router-dom';


function ErrorPage({ error, resetErrorBoundary }) {
    console.log('Error occured', error)

    const err = useRouteError()
    
    const sendLog = async () => {
        const sent = await logConsoleError({
            error: {
                message: err.message,
                stack: err.stack,
            }
        });
        if (sent) {
            console.log('Error log sent successfully');
        } else {
            console.error('Failed to send error log');
        }
    };

    useEffect(() => {
        if (err){ 
            sendLog()
        }
    }, [err])


    return (
        <div className="errorPage">
            <img className="errorImg" src={errorImg} alt="Technical Issue" />
            <p className="errorMsg">
                Something went wrong. Try clicking the refresh page button to reload the application.
            </p>
            <Button
                className='errorBtn'
                onClick={() => (location.href = '/')}
                type='primary'
            >
                Refresh Page
            </Button>

        </div>
    )
}

export default ErrorPage